import * as firebaseHelpers from '../helpers/Firebase/';
import { getLast4 } from '../utils';
import * as types from './actionTypes';

//TODO: move to helper
export function getFrequencyText(type) {
  switch (type) {
  case 0:
    return 'wk';
  case 1:
    return 'bi-wk';
  case 2:
    return 'mo';
  case 3:
    return '1st-15th';
  }
}

export function loadSubscriptions() {
  return async (dispatch, getState) => {
    const user = await firebaseHelpers.getCurrentUser(false);
    const { accountData } = getState().userReducer;

    if (user && accountData.cards) {
      firebaseHelpers.watchCollectionChanges(
        `users/${user.uid}/subscriptions`,
        subscriptions => {
          let allSubscriptions = [];

          for (var subscription of subscriptions) {
            const {
              amount,
              type,
              token,
              __id,
              organization,
              active,
              date,
              fund,
            } = subscription;
            const last4 = getLast4(token);
            const card = accountData.cards.find(({ last4: _last4 }) => _last4 === last4) || {};

            allSubscriptions.push({
              active,
              amount: amount,
              frequency: getFrequencyText(type),
              type,
              card,
              id: __id,
              organization,
              date,
              fund,
            });
          }
          dispatch({
            type: types.LOAD_SUBSCRIPTIONS,
            subscriptions: allSubscriptions,
          });
          return;
        }
      );
    }
  };
}
